import type { FC } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { LegacyTagKind, LegacyTagSize, LegacyTagVariant, Tag, type TagSlots } from "@stubhub/broadway-web";

interface Props {
  genres: readonly string[];
}

const tagClasses: TagSlots = { root: css({ textTransform: "capitalize", textWrap: "nowrap" }) };

export const GenreTags: FC<Props> = ({ genres }) =>
  genres.length > 0
    ? genres.map((genre) => (
        <Tag
          key={genre}
          kind={LegacyTagKind.Brand}
          size={LegacyTagSize.Small}
          variant={LegacyTagVariant.Borderless}
          classes={tagClasses}
        >
          {genre}
        </Tag>
      ))
    : null;
